import { MODULE } from "@/config/modules";
import {ModuleService} from "@/services/module-service";

export class PlanModule {
	ModuleID:MODULE = 0;
	MetaData:any;

	public constructor(data?:any){
		if (!data) return;
		this.ModuleID = data.ModuleID;
		this.MetaData = data.MetaData || {};
	}

	public getJSON(){
		return {
			ModuleID: this.ModuleID,
			MetaData: this.MetaData
		};
	}

	public getModuleName():string{
		let mod = ModuleService.modules.find(m=>m.id == this.ModuleID);
		if (!mod) {
			return "MODULE NIET GEVONDEN";
		}
		return mod.name;
	}

	public hasMetaData():boolean {
		let modsWithMetaData = [MODULE.EXTRA_DOSSIERS, MODULE.EXTRA_USERS, MODULE.DOCUMENTS];
		return modsWithMetaData.indexOf(this.ModuleID) != -1;
	}

	public getEditMetaDataComponent():null | string {
		if (this.ModuleID == MODULE.EXTRA_USERS){
			return "extra-users";
		}
		if (this.ModuleID == MODULE.EXTRA_DOSSIERS) {
			return "extra-dossiers";
		}
		if (this.ModuleID == MODULE.DOCUMENTS){
			return "max-documents";
		}
		if (this.ModuleID == MODULE.API_ACCESS) {
			return "api-access";
		}
		return null;
	}
}